var render = function render(){var _vm=this,_c=_vm._self._c;return _c('video',{ref:"player",class:{ 'bnw-gray': _vm.blackAndWhite },attrs:{"src":_vm.src,"muted":"muted","controls":!!_vm.controls ? 'controls' : null},domProps:{"muted":true}})
}
var staticRenderFns = []

export { render, staticRenderFns }